export enum message_type {
  TEXT = 'TEXT',
  VOICE = 'VOICE',
  INVISIBLE = 'INVISIBLE',
  TEXT_INTERRUPTED = 'TEXT_INTERRUPTED',
  VOICE_INTERRUPTED = 'VOICE_INTERRUPTED',
}

export enum author_type {
  USER = 'user',
  ASSISTANT = 'assistant',
  VALIDATOR = 'validator',
  BLOCKED_ASSISTANT = 'blocked_assistant',
}

export const messageBoxVariantClasses: Record<author_type, string> = {
  [author_type.USER]: 'mr-sm border-buttonLight',
  [author_type.ASSISTANT]: 'ml-sm bg-buttonLight border-transparent',
  [author_type.VALIDATOR]: 'ml-sm bg-red-100 border-red-400 text-red-800',
  [author_type.BLOCKED_ASSISTANT]: 'ml-sm bg-red-100 border-red-400 text-red-800',
};

export const messageInterruptedVariantClasses =
  'ml-sm bg-yellow-100 border-yellow-400 text-yellow-800';
